import api from './api';

const reportService = {
  /**
   * Get Sales Summary Report
   * @param {Object} params - Query parameters
   * @param {string} params.groupBy - Group by: 'day', 'week', 'month', 'year'
   * @param {string} params.customerId - Optional customer ID
   * @param {string} params.startDate - Start date (YYYY-MM-DD)
   * @param {string} params.endDate - End date (YYYY-MM-DD)
   * @param {number} params.page - Page number
   * @param {number} params.limit - Results per page
   */
  getSalesSummary: async (params = {}) => {
    try {
      const response = await api.get('/reports/sales-summary', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching sales summary report:', error);
      throw error;
    }
  },


  getVATPurchase: async (params = {}) => {
    try {
      const response = await api.get('/reports/vat-purchase', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching VAT purchase report:', error);
      throw error;
    }
  },


  getVATSales: async (params = {}) => {
    try {
      const response = await api.get('/reports/vat-sales', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching VAT sales report:', error);
      throw error;
    }
  },

  /**
   * Get VAT Return Summary
   * @param {Object} params - Query parameters
   */
  getVATReturn: async (params = {}) => {
    try {
      const response = await api.get('/reports/vat-return', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching VAT return summary:', error);
      throw error;
    }
  },

  /**
   * Get Payment Collection Report
   * @param {Object} params - Query parameters
   */
  getPaymentCollection: async (params = {}) => {
    try {
      const response = await api.get('/reports/payment-collection', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching payment collection report:', error);
      throw error;
    }
  },
  /**
   * Get VAT Detail Report
   * @param {Object} params - Query parameters
   * @param {string} params.groupBy - Group by: 'day', 'week', 'month', 'year'
   * @param {string} params.startDate - Start date (YYYY-MM-DD)
   * @param {string} params.endDate - End date (YYYY-MM-DD)
   * @param {string} params.language - Language ('en' or 'ar')
   */
  getVATDetail: async (params = {}) => {
    try {
      const response = await api.get('/reports/vat-detail', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching VAT detail report:', error);
      throw error;
    }
  },

  /**
   * Get Customer Sales Report
   * @param {Object} params - Query parameters
   */
  getCustomerSales: async (params = {}) => {
    try {
      const response = await api.get('/reports/customer-sales', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching customer sales report:', error);
      throw error;
    }
  },
};

export default reportService;
